<section class="container">
  <h6>Empresas Irregulares</h6>
  <bn-paginacao [total]="countEmpresa" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">CNPJ Empresa</th>
            <th scope="col">Tipo Irregularidade</th>
            <th scope="col">Data Início</th>
            <th scope="col">Data Fim</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaEmpresa" id="pointer" [routerLink]="['/irregularidade-empresa/', item.id]" >
            <td>{{item.cnpj | bnMask: 'CNPJRAIZ'}}</td>
            <td>{{item.tipo.nome}}</td>
            <td>{{item.dataInicio | date: 'dd/MM/yyyy' }}</td>
            <td>{{item.dataFim | date: 'dd/MM/yyyy'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </bn-paginacao>
</section>
